import { PostsSection } from "./PostsSection";
import { UpcomingEventsSection } from "./UpcomingEventsSection";

export const HomeRightSidebar = () => (
  <div className="homepage__sidebar">
    <UpcomingEventsSection />
    <PostsSection />
  </div>
);
